import { makeCustomerPhoneRepository } from 'modules/authentication/infra/repositories';

import UpdateCustomerPhoneUseCase from './implementations/UpdateCustomerPhoneUseCase';

let instance: UpdateCustomerPhoneUseCase | null = null;

export default function makeUpdateCustomerPhoneUseCase() {
  if (!instance) {
    const repository = makeCustomerPhoneRepository();

    instance = new UpdateCustomerPhoneUseCase(repository);
  }

  return instance;
}
